import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { Location, NgStyle } from '@angular/common';
import { HomePageService } from './pages/home-page/home-page.service';
import { SessionTokenService } from './services/session-token.service';
import { AuthService } from './services/auth.service';
import { firstValueFrom } from 'rxjs';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Toast, ButtonModule, NgStyle],
  template: `
    <main class="h-full">
      <div class="flex  headerHeight">
        <div class="flex align-items-center mb-1" style="height: 100%;">
          <h1 class="mr-1 mb-0 mt-0 company-name">fliptronic</h1>
          <div class="company-logo">
            <img
              src="assets/icons/company-logo.png"
              alt="Logo"
              style="width:100%; object-fit: contain;"
            />
          </div>
        </div>
        <div class="align-content-center" style="width: 100%;">
          <div style="display: flex; justify-content: end;" class="gap-2">
            @if (homePageService.focusedView$() !== 'none' || !isRootUrl()) {
            <div class="">
              <p-button
                label="Powrót"
                (onClick)="goBack()"
                size="small"
                [ngStyle]="{ float: 'inline-start' }"
                styleClass="small-font-btn small-btn-menu"
              />
            </div>
            } @if (token.token) { @if(isOnCodeList()){
            <div class="">
              <p-button
                label="Menu"
                (onClick)="goToHome()"
                size="small"
                [ngStyle]="{ float: 'inline-start' }"
                styleClass="small-font-btn small-btn-menu"
              />
            </div>
            } @else {

            <div class="">
              <p-button
                label="Lista kodów"
                (onClick)="goToCodesList()"
                size="small"
                [ngStyle]="{ float: 'inline-start' }"
                styleClass="small-font-btn small-btn-menu"
              />
            </div>
            }
            <div class="">
              <p-button
                label="Wyloguj"
                (onClick)="logout()"
                size="small"
                [ngStyle]="{ float: 'inline-start' }"
                styleClass="small-font-btn small-btn-menu"
              />
            </div>
            } @else {
            <div class="" style="display: flex; justify-content: end;">
              <p-button
                label="Zaloguj"
                (onClick)="login()"
                size="small"
                [ngStyle]="{ float: 'inline-start' }"
                styleClass="small-font-btn small-btn-menu"
              />
            </div>
            }
          </div>
        </div>
      </div>

      <div class="page-container">
        <router-outlet></router-outlet>
      </div>
      <p-toast [breakpoints]="{ '600px': { width: '90%', right: '16px' } }" />
    </main>
  `,
})
export class AppComponent {
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public location: Location,
    public token: SessionTokenService
  ) {}
  public homePageService = inject(HomePageService);
  private auth = inject(AuthService);
  private messages = inject(MessageService);

  public goToCodesList(): void {
    this.router.navigate(['/codes']);
  }
  public goToHome(): void {
    this.router.navigate(['/']);
  }

  isRootUrl(): boolean {
    const { pathname, search, hash } = window.location;
    const isRoot = pathname === '/' && !search && !hash;
    return isRoot;
  }

  isOnCodeList(): boolean {
    const { pathname, search, hash } = window.location;
    const res = pathname === '/codes' && !search && !hash;
    return res;
  }

  logout(): void {
    this.token.clear();
    this.router.navigate(['/']);
    this.messages.add({
      severity: 'success',
      summary: 'Zostałeś wylogowany',
      detail: '',
    });
  }

  async login(): Promise<void> {
    const ok = await firstValueFrom(this.auth.openLoginDialog$(''));
    if (ok) {
      this.messages.add({
        severity: 'success',
        summary: 'Zostałeś zalogowany',
        detail: '',
      });
    }
  }

  goBack() {
    const currentUrl = this.router.url;

    const backRoutes: { [key: string]: any[] } = {
      codes: ['/'],
      'code/import': ['/codes'],
      'code/use': ['/codes'],
      'auction-list': ['/'],
      'codes-reel': ['/'],
      'auction/': ['/auction-list'],
    };

    const matchedPath = Object.keys(backRoutes).find((path) =>
      currentUrl.includes(path)
    );

    if (matchedPath) {
      this.router.navigate(backRoutes[matchedPath]);
    } else if (
      currentUrl.includes('/auction/') &&
      currentUrl.includes('/summary')
    ) {
      const segments = currentUrl.split('/');
      const auctionId = segments[2];
      this.router.navigate(['/auction', auctionId]);
    } else {
      this.router.navigate(['/']);
    }

    this.homePageService.focusedView$.set('none');
  }
}
